import useVendor from '../hooks/useVendor';
import { redirectCampaignExpired } from '../helpers/utils';
import useCampaignDiscount from './useCampaignDiscount';

let validCampaignId;

/**
 * Verify that URL contains CampaignId (UUID) param and it has a value
 * @return {String}
 */
const useValidCampaignId = (): string => {
    const vendor = useVendor();
    const campaignDiscount = useCampaignDiscount();

    if (!validCampaignId) {
        validCampaignId = campaignDiscount.getCampaignUUID();

        if (!validCampaignId) {
            redirectCampaignExpired(vendor);
        }
    }

    return validCampaignId;
};

export default useValidCampaignId;
